import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ResourcesPage = ({ user, onLogout }) => {
  const [companyInfo, setCompanyInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCompanyInfo();
  }, []);

  const fetchCompanyInfo = async () => {
    try {
      const response = await axios.get(`${API}/public/company-info`);
      setCompanyInfo(response.data);
    } catch (error) {
      console.error('Error fetching company info:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navbar user={user} onLogout={onLogout} />
        <div className="flex items-center justify-center h-96">
          <div className="text-xl text-gray-600">Loading...</div>
        </div>
      </div>
    );
  }

  if (!companyInfo?.resources) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navbar user={user} onLogout={onLogout} />
        <div className="max-w-4xl mx-auto px-4 py-16 text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Provider Agreement</h1>
          <p className="text-gray-600">Content coming soon...</p>
          <Link to="/" className="text-blue-600 hover:underline mt-4 inline-block">
            Return to Home
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50" data-testid="resources-page">
      <Navbar user={user} onLogout={onLogout} />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-testid="resources-title">
            Provider Agreement
          </h1>
          <p className="text-xl text-gray-600">
            Agreement governing the participation of service providers on the GoodJob platform
          </p>
        </div>

        {/* Content */}
        <div 
          className="prose prose-lg max-w-none bg-white rounded-lg shadow-sm p-8"
          data-testid="resources-content"
          dangerouslySetInnerHTML={{ __html: companyInfo.resources }}
        />

        {/* Help CTA */}
        <div className="mt-12 text-center bg-gray-800 rounded-lg p-8 text-white">
          <h2 className="text-2xl font-bold mb-4">Need More Help?</h2>
          <p className="mb-6">Our support team is here to assist you.</p>
          <Link 
            to="/help" 
            className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
            data-testid="resources-help-btn"
          >
            Visit Help Center
          </Link>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default ResourcesPage;
